export abstract class ErrorLogger {
    abstract logError(type: string, error: unknown): void;
}
